var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"monitorSite px-4",attrs:{"fluid":""}},[_c('br'),_c('h1',[_vm._v(_vm._s(this.reportTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }